import { parseOpaqueToken, requireOpaqueToken } from '../shared/client-runtime.js';

export function inviteTokenFromHash(hash: string): string | null {
  if (!hash.startsWith('#')) return null;

  const params = new URLSearchParams(hash.slice(1));
  const keys = [...params.keys()];
  if (keys.length !== 1 || keys[0] !== 'invite') return null;

  return parseOpaqueToken(params.get('invite') ?? '');
}

export function publicInviteUrl(token: string, origin: string): string {
  const parsedToken = requireOpaqueToken(token);
  return `${origin.trim().replace(/\/$/, '')}/#invite=${encodeURIComponent(parsedToken)}`;
}
